import { render, staticRenderFns } from "./Huanbao.vue?vue&type=template&id=be186a9e&scoped=true"
import script from "./Huanbao.vue?vue&type=script&lang=js"
export * from "./Huanbao.vue?vue&type=script&lang=js"
import style0 from "./Huanbao.vue?vue&type=style&index=0&id=be186a9e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be186a9e",
  null
  
)

export default component.exports